/**
 * Static Google Authenticator store links (Apple + Google Play).
 * Rendered in two places on the security page (idle + scan steps), so
 * the copy lives in one place here.
 */
export const AUTHENTICATOR_STORES = [
  {
    id: 'apple' as const,
    label: 'App Store',
    smallLabel: 'Download on the',
    href: 'https://apps.apple.com/app/google-authenticator/id388497605',
  },
  {
    id: 'google' as const,
    label: 'Google Play',
    smallLabel: 'Get it on',
    href: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
  },
]
